import { FC } from "react"

import { useTranslation } from "react-i18next"

import { BetsTablesSection } from "components/settings/BetsTablesSection"
import { FakeBetsTab } from "components/settings/FakeBetsTab"
import { GameCardSection } from "components/settings/GameCardSection"

import { BetsTablesConfig, VipTier } from "services/settings/type"

import { GameCardConfig } from "types/api"

interface GeneralTabProps {
  betsTables: BetsTablesConfig
  currencies: Record<string, boolean>
  gameCardConfig: GameCardConfig | null
  onBetsTablesChange: (betsTables: BetsTablesConfig) => void
  onGameCardConfigChange: (config: GameCardConfig) => void
  onRefresh: () => Promise<void>
  canSeeFakeBets: boolean
  vipTiers: VipTier[]
}

export const GeneralTab: FC<GeneralTabProps> = ({
  betsTables,
  currencies,
  gameCardConfig,
  onBetsTablesChange,
  onGameCardConfigChange,
  onRefresh,
  canSeeFakeBets,
  vipTiers
}) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <section className="flex flex-col mt-6 mb-48 gap-12">
      <h3 className="text-xl font-semibold text-[rgba(6,7,21,1)] dark:text-white">{t("settings.general.title")}</h3>
      <BetsTablesSection betsTables={betsTables} currencies={currencies} onChange={onBetsTablesChange} onRefresh={onRefresh} />
      <GameCardSection config={gameCardConfig} onChange={onGameCardConfigChange} />
      {canSeeFakeBets && <FakeBetsTab currencies={currencies} vipTiers={vipTiers} />}
    </section>
  )
}
